export enum ActivitySelectionVersion {
  Blank = 0,
  RepeatLast = 5,
  SelectNext = 10,
}
